<template>
  <b-container fluid>
    <b-row no-gutters class="bordered-box-header align-items-center">
      <h2>Oceny kursantów dotyczące lektora</h2>
    </b-row>
    <b-row no-gutters class="bordered-box">
      <!-- <b-col cols="12">
        <filters-panel class="ml-3" @filters-search="onSearch"></filters-panel>
      </b-col>-->
      <b-col cols="12">
        <data-table
          class="m-2"
          ref="table"
          :dtFields="fields"
          :dtFieldsKey="primaryKey"
          :dtPageSizes="pageSizes"
          :dtPageSize="pageSize"
          :dtPage="currentPage"
          :dtItemsProvider="getData"
          :dtItemsTotal="total"
          sortBy="date"
          sortDesc="true"
        ></data-table>
      </b-col>
    </b-row>
  </b-container>
</template>
<script>
import { axios, eventBus } from "@/_infrastructure";
import moment from "moment";
import DataTable from "@/components/DataTable.vue";
// import FiltersPanel from "./RatingListFiltersPanel.vue";

const fields = [
  { key: "index", sortable: false, label: "#" },
  {
    key: "date",
    sortable: true,
    label: "Data odbycia rozmowy / lekcji",
    formatter: value => {
      return moment(value).format("YYYY-MM-DD HH:mm");
    }
  },
  { key: "rating", sortable: true, label: "Ocena" },
  { key: "comment", sortable: true, label: "Komentarz do oceny" },
  { key: "student", sortable: true, label: "Kursant" }
];

const primaryKey = "id";

export default {
  components: { DataTable },
  props: ["id"],
  data() {
    return {
      filters: null,
      pageSizes: [10, 20, 50, 200],
      pageSize: 20,
      currentPage: 1,
      fields: fields,
      primaryKey: primaryKey,
      isLoading: true,
      total: 0
    };
  },
  methods: {
    onSearch(filters) {
      this.filters = filters;
      this.$refs.table.refresh();
    },
    getData(ctx) {
      var self = this;
      var queryObject = { ...ctx, ...this.filters }; //FiltersPanel.queryObject(ctx);

      queryObject.lectorId = this.id;

      return axios
        .get("lectors/rating", { params: queryObject })
        .then(result => {
          self.total = result.data.total;
          return result.data.rows;
        })
        .catch(err => {
          eventBus.$emit("unhandled-error", err);
          return null;
        });
    }
  }
};
</script>
<style lang="scss" scoped>
.bordered-box-header {
  margin-top: 20px;
  padding: 10px;
  margin-bottom: 0px;
  background: rgba(0, 0, 0, 0.03);
  border: 1px solid rgba(0, 0, 0, 0.125);
}

.bordered-box {
  border: 1px solid rgba(0, 0, 0, 0.125);
  padding: 10px;
}
</style>
